/**
 * Pick a `lucide-react` icon component for a file based on its MIME type
 * and/or filename extension. Shared between the `AuiFiles` browser and the
 * composer attachment chips so both render the same visual cue per type.
 */

import {
  FileCode,
  FileImage,
  FileText,
  File as FileIcon,
  type LucideIcon,
} from 'lucide-react';

export interface FileLike {
  name: string;
  contentType?: string;
}

export function iconForFile(entry: FileLike): LucideIcon {
  const name = entry.name ?? '';
  const ext = name.split('.').pop()?.toLowerCase() ?? '';
  const contentType = (entry.contentType ?? '').toLowerCase();

  if (contentType.startsWith('image/') || ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(ext)) {
    return FileImage;
  }
  if (['ts', 'tsx', 'js', 'jsx', 'json', 'py', 'rb', 'go', 'rs', 'sh', 'css', 'html', 'xml', 'yaml', 'yml'].includes(ext)) {
    return FileCode;
  }
  if (['md', 'markdown', 'txt', 'csv', 'log'].includes(ext) || contentType.startsWith('text/')) {
    return FileText;
  }
  return FileIcon;
}
